<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-13 14:48:42
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-02-18 17:30:23
 * @FilePath: /lobby/src/components/FootContent.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="foot">
    <div class="btn-group">
      <div class="left" @click="onSearchGames">
        <i class="bi bi-search"></i> {{ $t('button.searchGame') }}
      </div>
      <div class="right" @click="onAllGames">
        <i class="bi bi-grid-3x3-gap"></i> {{ $t('button.allgame') }}
      </div>
    </div>
    <div class="foot-top">
      <div style="margin-left: 0.2rem">
        <img class="logo" v-if="country != 'GH'" :src="`${resBaseUrl}logo.png`" alt="" />
        <img
          class="logo"
          style="width: 2.2rem; height: auto; margin-bottom: 0.13rem; margin-right: 0rem"
          v-else
          :src="`${resBaseUrl}logo_bigwins.png`"
          alt=""
        />
        <img v-if="country == 'ET'" class="icon" :src="`${resBaseUrl}icon_21.png`" alt="" />
        <img v-else class="icon" :src="`${resBaseUrl}icon_18.png`" alt="" />
      </div>
      <DhLanguage />
    </div>
    <div class="foot_con">
      <!-- <li><a href="#">About</a></li> -->
      <!-- <li><a href="#">T&C&#8217;s</a></li> -->
      <!-- <li><a href="#">FAQs</a></li> -->
      <div @click="onShowTC" style="font-size: 0.24rem; text-decoration: underline; color: #ffddac">
        {{ $t('message.tcTitle') }}
      </div>
      <p style="padding: 3%; width: 94%">
        {{ $t(`message.tc.${country}`, { years: country == 'ET' ? 21 : 18 }) }}
      </p>
    </div>
    <div class="foot_link">
      <div class="link-icon">
        <img
          v-for="(link, index) in currentLinks"
          :src="`${resBaseUrl}${link}`"
          :key="index"
          width="100%"
        />
      </div>
      <!-- <p>&copy; 2023 Crypto-Games.io. All Rights Reserved.</p> -->
    </div>
  </div>
</template>
<script>
import DhLanguage from '@/components/ChangeLanguage.vue'
import { config } from '@/common/config'
import { mapState } from 'pinia'
import { useUserStore } from '@/stores/user'
export default {
  name: 'DhFootContent',
  components: {
    DhLanguage
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      linksET: [
        // 'foot_partner_arifpay.jpg',
        'foot_partner_etoplay.jpg',
        'foot_partner_hub88.jpg',
        'foot_partner_infobip.jpg',
        'foot_partner_onetouch.jpg',
        'foot_partner_pragmatic.jpg',
        'foot_partner_santim.jpg',
        'foot_partner_telegram.jpg'
      ],
      linksCI: [
        'foot_partner_b-pay.jpg',
        'foot_partner_etoplay.jpg',
        'foot_partner_hub88.jpg',
        'foot_partner_infobip.jpg',
        'foot_partner_onetouch.jpg',
        'foot_partner_pragmatic.jpg',
        'foot_partner_Pixel-innov.jpg',
        'foot_partner_telegram.jpg'
      ],
      linksKE: [
        'foot_mpesa.jpg',
        'foot_partner_etoplay.jpg',
        'foot_partner_hub88.jpg',
        'foot_partner_infobip.jpg',
        'foot_partner_onetouch.jpg',
        'foot_partner_pragmatic.jpg',
        'foot_partner_telegram.jpg'
      ],
      linksTZ: [
        'foot_partner_etoplay.jpg',
        'foot_partner_hub88.jpg',
        'foot_partner_infobip.jpg',
        'foot_partner_onetouch.jpg',
        'foot_partner_pragmatic.jpg',
        'foot_partner_telegram.jpg',
        'foot_partner_aritel.jpg',
        'foot_partner_halopesa.jpg',
        'foot_partner_tigopesa.jpg',
        'foot_partner_vodacom.jpg'
      ],
      linksGH: [
        // 'foot_partner_arifpay.jpg',
        'foot_AirtelTigo.png',
        'foot_deposit_mtn_mobile_money.png',
        'foot_partner_vodacom.jpg',
        'foot_partner_etoplay.jpg',
        'foot_partner_hub88.jpg',
        'foot_partner_infobip.jpg',
        'foot_partner_onetouch.jpg',
        'foot_partner_pragmatic.jpg',
        // 'foot_partner_santim.jpg',
        'foot_partner_telegram.jpg'
      ]
    }
  },
  computed: {
    ...mapState(useUserStore, ['country']),
    currentLinks() {
      const linkMap = {
        ET: this.linksET,
        KE: this.linksKE,
        CI: this.linksCI,
        TZ: this.linksTZ,
        GH: this.linksGH
      }
      return linkMap[this.country] || this.linksET
    }
  },
  mounted() {},

  methods: {
    onSearchGames() {
      this.$router.push({ name: 'searchGame', params: { type: 0 } })
    },
    onAllGames() {
      this.$router.push({ name: 'searchGame', params: { type: 1 } })
    },
    onShowTC() {
      this.$router.replace('/tc')
    }
  }
}
</script>
<style lang="scss" scoped>
.foot {
  .btn-group {
    display: flex;
    justify-content: space-around;
    font-size: 0.28rem;
    margin-top: 0.5rem;

    i {
      font-size: 0.3rem;
      margin-right: 0.1rem;
    }

    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 47%;
      height: 0.9rem;
      background: #aa884a;
      border-radius: 0.45rem;
    }

    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 47%;
      height: 0.9rem;
      background: #ceb45f;
      border-radius: 0.45rem;
    }
  }

  .foot-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;

    .logo {
      width: 2.1rem;
      margin-right: 20px;
    }

    .icon {
      width: 0.4rem;
      padding-bottom: 0.1rem;
    }
  }

  .foot_con {
    margin: 0px;
    width: 100%;
    overflow: hidden;
    text-align: center;

    li {
      text-align: center;
      display: inline;
      margin: 0px;
      padding: 0 0.4rem;
      line-height: 0.6rem;

      a {
        font-size: 0.24rem;
        color: #ffddac;
        text-decoration: none;
      }
    }

    p {
      font-size: 0.22rem;
      line-height: 0.2rem;
      color: #999999;
      text-align: left;
      width: 100%;
      max-height: 9999px;
      margin: 0px;
      padding: 0px;
      text-align: justify;
    }
  }

  .foot_link {
    margin: 0px;
    width: 100%;
    overflow: hidden;

    p {
      font-size: 0.16rem;
      line-height: 0.16rem;
      color: #999999;
      text-align: center;
      width: 100%;
      max-height: 9999px;
      margin: 0;
      padding: 0px;
      display: inline-block;
    }

    .link-icon {
      display: flex;
      flex-wrap: wrap;
      column-gap: 0.12rem;
      row-gap: 0.2rem;
      padding: 4% 10%;
      width: 80%;
      justify-content: center;

      img {
        width: 0.9rem;
        height: 0.5rem;
        border-radius: 0.08rem;
      }
    }
  }
}
</style>
